import MarketSliderRedux from './market_slider_redux';

export default MarketSliderRedux;
